/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'efb-section',
  styleUrl: 'section.scss',
  shadow: true,
})
export class EfbSection {
  /**
   * Props
   */
  @Prop() background?: 'white' | 'purple' | 'pink' | 'blue' = 'white';

  @Prop() contentSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

  render() {
    return (
      <Host>
        <section class={`section has-${this.background}-background`}>
          <div class={`content is-${this.contentSize}-size`}>
            <slot />
          </div>
        </section>
      </Host>
    );
  }
}
